import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';
import { Empty, Upload, Progress, Card, Button, Alert, Tag } from 'antd';
import Lottie from 'lottie-react';

export const XThemeEmptyBatche = styled(Empty)`
	width: 100%;
	position: relative;
	border-radius: 20px;
	border-style: solid;
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	background: ${({ theme }) => theme.colors.white};
	padding: 30px 15px;
	.ant-empty-image {
		height: auto;
		img {
			height: 250px;
		}
	}
`;
export const XThemeBulkUpload = styled(Upload)`
	width: 100%;
	position: relative;
`;
export const XThemeBulkWrapper = styled.div`
	width: 100%;
	position: relative;
	.ant-upload-drag-container {
		padding: 5px 15px;
		.ant-upload-drag-icon {
			margin-bottom: 10px !important;
		}
		.ant-upload-text {
			font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
			font-weight: 400 !important;
			font-size: 15px !important;
			line-height: 24px !important;
			letter-spacing: -0.02em !important;
			color: ${({ theme }) => theme.colors.themeColor1} !important;
			span {
				color: ${({ theme }) => theme.colors.themeColor8};
			}
		}
		.ant-upload-hint {
			font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
			margin-bottom: 0px !important;
			font-weight: 400 !important;
			font-size: 13px !important;
			line-height: 20px !important;
			color: rgba(33, 34, 38, 0.5) !important;
		}
	}
	.ant-upload-drag {
		background: #f2f8fa !important;
		&:hover {
			border-color: ${({ theme }) => theme.colors.themeColor8} !important;
		}
	}
	.has-error .ant-upload-drag {
		background: rgba(201, 37, 25, 0.02) !important;
		border: 1px solid rgba(201, 37, 25, 0.1) !important;
	}
`;
export const XThemeCardUploading = styled(Card)`
	width: 100%;
	position: relative;
	text-align: center;
	background: #f2f8fa !important;
	.title {
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		font-weight: 400 !important;
		font-size: 15px !important;
		line-height: 24px !important;
		letter-spacing: -0.02em !important;
		color: ${({ theme }) => theme.colors.themeColor1} !important;
		span {
			color: ${({ theme }) => theme.colors.themeColor8};
		}
	}
	.title2 {
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		margin-bottom: 0px !important;
		font-weight: 400 !important;
		font-size: 13px !important;
		line-height: 20px !important;
		color: rgba(33, 34, 38, 0.5) !important;
	}
	@media only screen and (max-width: 768px) {
	}
`;
export const XThemeCSVLottie = styled(Lottie)`
	position: relative;
	background: transparent;
	width: 100px;
	margin: 0px auto;
	@media only screen and (max-width: 768px) {
		width: 100px;
		position: relative;
		margin: 0px auto;
	}
`;
export const XThemePDFProgress = styled(Progress)`
	width: 100%;
	position: relative;
	.ant-progress-inner {
		background: ${({ theme }) => theme.colors.white};
	}
	.ant-progress-bg {
		background: ${({ theme }) => theme.colors.themeColor8};
	}
	@media only screen and (max-width: 768px) {
	}
`;
export const XThemeCancelProgressBTN = styled(Button)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	border-radius: 8px;
	font-weight: 500;
	font-size: 12px;
	line-height: 18px;
	color: ${({ theme }) => theme.colors.themeColor8};
	box-shadow: none;
	&:hover {
		background: linear-gradient(
			90deg,
			${({ theme }) => theme.colors.themeColor25} 20.31%,
			${({ theme }) => theme.colors.themeColor8} 100%
		) !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
		color: ${({ theme }) => theme.colors.white} !important;
	}
	@media only screen and (max-width: 768px) {
	}
`;
export const XThemeErrors = styled(Alert)`
	border-radius: 10px;
	.ant-alert-message {
		font-weight: 400;
		font-size: 13px;
		line-height: 32px;
		letter-spacing: -0.02em;
	}
	.ant-alert-error {
		background: rgba(201, 37, 25, 0.02);
		border: 1px solid rgba(201, 37, 25, 0.1);
		color: #c92519;
	}
	@media only screen and (max-width: 768px) {
	}
`;
export const XThemeBulkTags = styled(Tag)`
	border-radius: 20px;
	font-family: ${({ theme }) => theme.colors.fontInter} !important;
	font-size: 12px !important;
	line-height: 24px !important;
	font-style: normal;
	font-weight: 400;
	letter-spacing: 0.36px;
	padding-left: 22px;
	padding-right: 10px;
	border: none;
	&:before {
		content: '\u{25CF}';
		position: absolute;
		top: 0px;
		left: 10px;
		font-size: 10px;
	}
	border: none;
	&.processing {
		background: #fbead4 !important;
		color: #ed982a !important;
	}
	&.completed {
		background: #d7f0e5 !important;
		color: #36b37e !important;
	}
	&.pending {
		background: #fff8d9 !important;
		color: #cfae2a !important;
	}
	&.creating_batch {
		background: #e6f7ff !important;
		color: #1890ff !important;
	}
	&.batch_created {
		background: #d9f7be !important;
		color: #52c41a !important;
	}
	&.processing_batch {
		background: #f0f5ff !important;
		color: #597ef7 !important;
	}
	&.failed {
		background: #ffccc7 !important;
		color: #ff4d4f !important;
	}
	&.partial {
		background: #fff1b8 !important;
		color: #faad14 !important;
	}
	&.retrying_batch_creating {
		background: #ffd6e7 !important;
		color: #eb2f96 !important;
	}
	&.inputs_taken {
		background: #e8f5ff !important;
		color: #2b95d6 !important;
	}
	&.processing_inputs {
		background: #ebf5ec !important;
		color: #52c41a !important;
	}
	&.human_intervention {
		background: #d0ebff !important;
		color: #68a1cf !important;
	}
	&.inconclusive {
		background: #f2eaf6 !important;
		color: #957fd4 !important;
	}
	&.letter_prepared {
		background: #d3f9d8 !important;
		color: #5eaa69 !important;
	}
	&.rejected,
	&.not_covered {
		background: #ffe2e5 !important;
		color: #e48383 !important;
	}
	@media only screen and (max-width: 767.99px) {
	}
`;
export const XThemeBulkDetailsCard = styled(Card)`
	width: 100%;
	position: relative;
	border-radius: 20px;
	border-style: solid;
	border: 1px solid ${({ theme }) => theme.colors.themeColor22};
	height: 100%;
	&.gradientBg {
		background: ${({ theme }) => theme.CQColors.white}
			url('../../images/batch-gradient-bg.svg') no-repeat bottom center !important;
		background-size: contain !important;
	}
	h1 {
		margin: 0px;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		font-weight: 500 !important;
		font-size: 16px !important;
		line-height: 26px !important;
		color: ${({ theme }) => theme.colors.themeColor1};
		span {
			color: ${({ theme }) => theme.colors.themeColor8};
		}
	}
	h6 {
		margin: 0px;
		font-family: ${({ theme }) => theme.CQColors.fontInter};
		font-weight: 400 !important;
		font-size: 14px !important;
		line-height: 22px !important;
		color: ${({ theme }) => theme.colors.themeColor4};
	}
	h4 {
		margin: 0px;
		font-family: ${({ theme }) => theme.CQColors.fontInter};
		font-weight: 500;
		font-size: 16px;
		line-height: 32px;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	&.progressBarBody {
		.ant-card-body {
			padding-bottom: 0px !important;
		}
	}
`;
export const XThemeBulkDetailsNoCases = styled(Card)`
	width: 100%;
	position: relative;
	border-radius: 16px;
	border-style: solid;
	border: 1px solid transparent;
	height: 100%;
	.ant-card-body {
		padding: 15px;
	}
	h1 {
		margin: 0px;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		font-weight: 500 !important;
		font-size: 18px !important;
		line-height: 24px !important;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	h6 {
		margin: 0px;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		font-weight: 400 !important;
		font-size: 12px !important;
		line-height: 16px !important;
		color: #425166;
	}
	// &.pending {
	// 	background: #fff3bf !important;
	// 	cursor: pointer;
	// }
	// &.inProgress {
	// 	background: #ffe8cc !important;
	// 	cursor: pointer;
	// }
	// &.requireUserInput {
	// 	background: #d0ebff !important;
	// 	cursor: pointer;
	// }
	// &.inconclusive {
	// 	background: #f2eaf6 !important;
	// 	cursor: pointer;
	// }
	// &.letterPrepared {
	// 	background: #d3f9d8 !important;
	// 	cursor: pointer;
	// }
	// &.rejected {
	// 	background: #ffe2e5 !important;
	// 	cursor: pointer;
	// }
	// &.ready {
	// 	background: #e5fbe8 !important;
	// 	cursor: pointer;
	// }

	height: 136px;
	background: #ffffff;
	border: 1px solid rgba(80, 88, 135, 0.1);
	border-radius: 10px;

	&.pending.active {
		border: 1px solid #cfae2a;
	}
	&.inProgress.active {
		border: 1px solid #e2a360;
	}
	&.requireUserInput.active {
		border: 1px solid #68a1cf;
	}
	&.inconclusive.active {
		border: 1px solid #957fd4;
	}
	&.letterPrepared.active {
		border: 1px solid #5eaa69;
	}
	&.rejected.active {
		border: 1px solid #e48383;
	}
	&.ready.active {
		border: 1px solid #80f891;
	}
`;
export const XThemeBulkOverallProgress = styled(Progress)`
	width: 100%;
	position: relative;
	height: 150px !important;
	.ant-progress-inner {
		position: absolute !important;
		width: 200px !important;
		height: 200px !important;
		top: 10%;
		left: 50%;
		transform: translate(-50%, 0%);
		@media (min-width: 992px) and (max-width: 1204px) {
			/* top: 40%; */
		}
	}
	.ant-progress-circle-trail {
		stroke: #e9ecf1 !important;
	}
	.ant-progress-text {
		bottom: 50px !important;
		font-weight: 700 !important;
		font-size: 26px !important;
		line-height: 31px !important;
		font-family: ${({ theme }) => theme.CQColors.fontInter}!important;
		color: #169191 !important;
	}
`;
export const XThemeRefreshBTN = styled(Button)`
	/* position: absolute;
	left: 0;
	right: 0;
	bottom: 12%; */
	position: relative;
	/* margin: -30px auto; */
	/* display: block; */
	background: rgba(0, 114, 153, 0.05);
	border: 1px solid rgba(0, 114, 153, 0.1);
	border-radius: 20px;
	font-family: ${({ theme }) => theme.CQColors.fontInter}!important;
	width: 115px;
	font-weight: 500 !important;
	font-size: 14px;
	line-height: 20px;
	padding: 10px 0px;
	color: ${({ theme }) => theme.colors.themeColor8};
	&:hover {
		background: linear-gradient(
			90deg,
			${({ theme }) => theme.colors.themeColor25} 20.31%,
			${({ theme }) => theme.colors.themeColor8} 100%
		) !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
		color: ${({ theme }) => theme.colors.white} !important;
		img {
			filter: brightness(0) invert(1) !important;
		}
	}
	/* @media only screen and (max-width: 1204px) {
		position: relative;
		bottom: auto;
	}*/
	@media only screen and (max-width: 991px) {
		display: inline;
	}
	&.voiceAssistance {
		position: absolute;
		left: 50%;
		bottom: 10px;
		transform: translateX(-50%);
	}
`;
export const XThemeStartCancelBTN = styled(Button)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.themeColor23};
	border-radius: 20px !important;
	font-weight: 500 !important;
	font-size: 12px !important;
	line-height: 16px !important;
	color: ${({ theme }) => theme.colors.themeColor8};
	padding: 7px 30px !important;
	&.background {
		background: ${({ theme }) => theme.colors.themeColor8};
		color: ${({ theme }) => theme.colors.white};
	}
	&:hover {
		background: linear-gradient(
			90deg,
			${({ theme }) => theme.colors.themeColor25} 20.31%,
			${({ theme }) => theme.colors.themeColor8} 100%
		) !important;
		border-color: ${({ theme }) => theme.colors.white} !important;
		color: ${({ theme }) => theme.colors.white} !important;
		/* img {
			filter: brightness(0) invert(1) !important;
		} */
	}

	@media only screen and (max-width: 991px) {
	}
`;
export const XThemeProgressLottie = styled(Lottie)`
	position: absolute;
	width: 40px;
	background: transparent;
	bottom: 0px;
	svg {
		width: 100% !important;
		height: 120px !important;
	}
	&.loader1 {
		margin-bottom: -75px;
	}
	&.loader2 {
		margin-bottom: -85px;
	}
`;

export const XThemeBulkDetailsRevenueImpact = styled(Card)`
	width: 100%;
	position: relative;
	border-radius: 16px;
	border-style: solid;
	border: 1px solid transparent;
	height: 100%;
	overflow: hidden;
	.ant-card-body {
		padding: 24px;
	}
	.fixInfo {
		position: absolute;
		top: 10px;
		right: 15px;
		cursor: pointer;
		color: ${({ theme }) => theme.colors.themeColor1};
		opacity: 0.7;
	}
	.fixInfo2 {
		position: absolute;
		top: 20px;
		right: 50px;
		cursor: pointer;
		color: ${({ theme }) => theme.colors.themeColor1};
		opacity: 0.7;
	}
	h6 {
		width: 100%;
		display: block;
		margin: 0px;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		font-weight: 500 !important;
		font-size: 16px !important;
		line-height: 100% !important;
		color: #425166;
	}
	h1 {
		margin: 0px;
		font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
		font-weight: 500 !important;
		font-size: 22px !important;
		line-height: 100% !important;
		color: ${({ theme }) => theme.colors.themeColor1};
	}
	&.denialAmount {
		background: #fdefdf !important;
	}
	&.potentialRecovery {
		background: #e3f9e7 !important;
	}
	&.writeOff {
		background: #fdecee !important;
	}
`;
export const XThemeCustomLoader = styled.div`
	position: absolute;
	bottom: 0px;
	width: calc(100% - 20px);
	height: 2px;
	bottom: 0px;
	left: 10px;
	right: 10px;
	border-radius: 0px 0px 20px 20px;
	overflow: hidden;
	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0px;
		right: 0px;
		width: 100%;
		height: 100%;
		animation: shimmer 3s infinite;
		z-index: 99;
	}
	&.loader1 {
		&::before {
			background: #e2a360;
		}
	}
	&.loader2 {
		&::before {
			background: #83c58f;
		}
	}
	&.loader3 {
		&::before {
			background: #c7a1a6;
		}
	}

	@keyframes shimmer {
		0% {
			transform: translateX(-100%);
		}
		100% {
			transform: translateX(100%);
		}
	}
`;
